"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/EnterEmail/EnterEmail.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reacthookform = require('react-hook-form');
var _useFieldErrorDisplay = require('shared/hooks/useFieldErrorDisplay'); var _useFieldErrorDisplay2 = _interopRequireDefault(_useFieldErrorDisplay);
var _reactrouterdom = require('react-router-dom');

var _routes = require('web/chat/routes'); var _routes2 = _interopRequireDefault(_routes);
var _signup = require('shared/validation/signup');
var _errors = require('shared/errors');

var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _amplitude = require('web/services/amplitude'); var _amplitude2 = _interopRequireDefault(_amplitude);
var _posthog = require('web/services/posthog'); var _posthog2 = _interopRequireDefault(_posthog);









var _signupAttribution = require('web/services/signupAttribution');
var _AuthFrame = require('web/components/AuthFrame');
var _Form = require('web/components/Form');
var _types = require('web/screens/Login/types');


var _components = require('web/screens/Signup/components');





 const genericErrorMsg = "Something went wrong. Try again, or contact support@bloomtext.com."; exports.genericErrorMsg = genericErrorMsg
const acceptedStatuses = new Set(['Cold', 'Inactive', 'Unverified Email'])
// Mirrors command.IsSignupDistinctIDShaped (task_signup_recovery.go): the
// "bt_signup:" prefix, a 64-byte ceiling (10 of which are the prefix, leaving
// 54), and an unreserved body. The client copy of signup_email_submitted must
// be gated on exactly the same shape the server gates on — a looser pattern
// here would land a client-only row on an identity the server rejected, and
// that person can never be aliased onto a user key.
const signupDistinctIdPattern = /^bt_signup:[A-Za-z0-9:_-]{1,54}$/

// Must equal command.SignupIdentityAttribution (task_signup_recovery.go),
// which is exported precisely so a rename cannot split the dashboard filter
// that joins this event to the recovery chain. This is the one copy the
// compiler cannot check.
const SIGNUP_IDENTITY_ATTRIBUTION = 'attribution'

const signupOutcomeByStatus = {
  'Cold': 'cold',
  'Inactive': 'inactive',
  'Unverified Email': 'unverified_email',
  'Active': 'active',
}








const patientLoginRoute = `${_routes2.default.LOGIN.ROOT}?${_types.LOGIN_TAB_PARAM}=patient`

const EnterEmail = ({ onPatientSignIn }) => {
  _react.useEffect.call(void 0, () => {
    _signupAttribution.severStaleAnalyticsIdentity.call(void 0, )
    _signupAttribution.ingestSignupAttribution.call(void 0, )
    _amplitude2.default.logEvent("SIGN_UP_ENTER_EMAIL")
    _signupAttribution.captureSignupEvent.call(void 0, 'app signup reached', { signup_route: 'welcome' })
  }, [])
  const [stage, setStage] = _react.useState('form')
  const [submittedEmail, setSubmittedEmail] = _react.useState.call(void 0, '')
  const [hasError, setHasError] = _react.useState.call(void 0, false)

  const defaultEmail = _signupAttribution.getSignupEmailPrefill.call(void 0, )
  const { register, resetField, handleSubmit, formState, watch } = _reacthookform.useForm.call(void 0, {
    resolver: _signup.emailResolver,
    // Validate a field when it loses focus, then as it is edited to clear the
    // error: never while its first value is still being typed.
    mode: 'onTouched',
    defaultValues: { email: defaultEmail },
  })
  const { isSubmitting, isValid } = formState

  _react.useEffect.call(void 0, 
    () => {
      resetField('email', { defaultValue: defaultEmail })
    },
    [defaultEmail, resetField],
  )

  // Editing the email clears "already used" and a failed check.
  const typedEmail = watch('email')
  // Shown once they leave the field after typing, never while they type.
  const display = _useFieldErrorDisplay2.default.call(void 0, { email: formState.errors.email })
  const emailError = display.shown('email')
  _react.useEffect.call(void 0, 
    () => {
      if (typedEmail === submittedEmail) return
      setHasError(false)
      setStage(s => s === 'used' ? 'form' : s)
    },
    [typedEmail, submittedEmail],
  )

  const useDifferentEmail = () => {
    resetField('email', { defaultValue: '' })
    setSubmittedEmail('')
    setStage('form')
  }

  const onSubmit = async ({ email }) => {
    setHasError(false)
    setSubmittedEmail(email)
    let submitEvent
    let path = ''
    let signupDistinctId = ''
    try {
      _signupAttribution.identifySignupEmail.call(void 0, email)
      submitEvent = _signupAttribution.mintSignupSubmitEvent.call(void 0, )
      path = _signupAttribution.getSignupForwardingPath.call(void 0, submitEvent)
      signupDistinctId = new URLSearchParams(path).get('bt_signup_distinct_id') || ''
    } catch (e) {
      // Telemetry preparation must never prevent the signup request.
    }
    let hasCaptured = false
    const captureOnce = (outcome) => {
      if (hasCaptured || !submitEvent || !signupDistinctIdPattern.test(signupDistinctId)) return
      hasCaptured = true
      try {
        _posthog2.default.capture('signup_email_submitted', {
          ..._signupAttribution.getSignupSubmitEventProperties.call(void 0, path),
          capture_source: 'client',
          identity_source: SIGNUP_IDENTITY_ATTRIBUTION,
          outcome,
        }, {
          uuid: submitEvent.id,
          timestamp: submitEvent.timestamp,
        })
      } catch (e) {
        // Event construction and mocked SDKs must be as non-blocking as the wrapper.
      }
    }

    return _client2.default.checkWelcomeCredential(email, path)
      .then(r => {
        if (r.Status === "Server Error") throw new (0, _errors.BlmError)('Server Error')
        if (acceptedStatuses.has(r.Status)) {
          captureOnce(signupOutcomeByStatus[r.Status] || 'error')
          setStage('sent')
          return
        }
        if (r.Status === "Active") {
          captureOnce(signupOutcomeByStatus[r.Status] || 'error')
          setStage('used')
          return
        }

        // Invalid and unknown statuses are handled backend responses. Say so
        // inline and keep the form, without reporting a client-side exception.
        captureOnce('error')
        setHasError(true)
      })
      .catch(e => {
        captureOnce('error')
        log.error(e)
        setHasError(true)
      })
  }

  if (stage === 'sent') {
    return (
      _react2.default.createElement(_components.SignupStepWrapper, { showProgress: false, __self: this, __source: {fileName: _jsxFileName, lineNumber: 175}}
        , _react2.default.createElement(_components.SignupStepHeader, {
          iconType: "email",
          title: "Check your email"  ,
          subtitle: (
            _react2.default.createElement(_react2.default.Fragment, null, "We sent a sign-up link to "
                    , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 181}},  submittedEmail ), ". Open it on any device to finish."

            )
          ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 176}}
        )
        , _react2.default.createElement('p', { className: "auth-note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 186}}, "Don't see it? Check your spam folder. The link works once."

        )
        , _react2.default.createElement(_Form.Button, { isInverted: true, onClick: useDifferentEmail, __self: this, __source: {fileName: _jsxFileName, lineNumber: 189}}, "Use a different email"   )
      )
    )
  }

  const isUsed = stage === 'used'

  return (
    _react2.default.createElement(_components.SignupStepWrapper, {
      showProgress: !isUsed,
      below: isUsed ? undefined : (
        _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 200}}, "Already have an account? "    , _react2.default.createElement(_reactrouterdom.Link, { to: _routes2.default.LOGIN.ROOT, __self: this, __source: {fileName: _jsxFileName, lineNumber: 200}}, "Log in" ))
      ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 197}}

      , _react2.default.createElement('form', { onSubmit: handleSubmit(onSubmit, errs => display.onSubmitErrors(Object.keys(errs))), __self: this, __source: {fileName: _jsxFileName, lineNumber: 203}}
        , _react2.default.createElement(_components.SignupStepHeader, {
          title: "Create a staff account"   ,
          subtitle: "For people who work at a healthcare organization. We'll email you a link to finish."              , __self: this, __source: {fileName: _jsxFileName, lineNumber: 204}}
        )
        , _react2.default.createElement(_Form.InputSection, {
          autoFocus: true,
          title: "Work email" ,
          inputType: "email",
          autoComplete: "email",
          placeholder: "name@clinic.com",
          errorMessage: _optionalChain([emailError, 'optionalAccess', _ => _.message]),
          inputProps: { ...display.bind(register('email')), 'aria-invalid': isUsed || !!emailError || undefined },
          className: isUsed ? 'signup-email--used' : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 208}}
        )
        ,  isUsed && (
          _react2.default.createElement(_AuthFrame.Callout, {
            message: "An account already uses this email."     ,
            detail: "Log in instead, or reset your password if you've forgotten it."          ,
            actions: (
              _react2.default.createElement(_react2.default.Fragment, null
                , _react2.default.createElement(_reactrouterdom.Link, {
                  to: _routes.makeRoute.call(void 0, _routes2.default.LOGIN.EMAIL_LOGIN, { email: submittedEmail }),
                  className: "auth-chip auth-chip--primary" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 224}}
, "Log in"

                )
                , _react2.default.createElement(_reactrouterdom.Link, { to: _routes2.default.LOGIN.FORGOT_PASSWORD, className: "auth-chip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 230}}, "Forgot password?"

                )
              )
            ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 219}}
          )
        )
        ,  hasError && _react2.default.createElement(_AuthFrame.Callout, { message: exports.genericErrorMsg, __self: this, __source: {fileName: _jsxFileName, lineNumber: 237}} ) 
        ,  !isUsed && (
          _react2.default.createElement(_components.SignupStepControls, {
            isNextLoading: isSubmitting,
            isNextDisabled: !isValid, __self: this, __source: {fileName: _jsxFileName, lineNumber: 239}}
          )
        )
        ,  !isUsed && (
          _react2.default.createElement(_react2.default.Fragment, null
            , _react2.default.createElement('div', { className: "auth-divider", __self: this, __source: {fileName: _jsxFileName, lineNumber: 246}} )
            , _react2.default.createElement(_components.SignupStepNotice, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 247}}, "Getting messages from a clinic?"
                  , ' '
              , _react2.default.createElement(_reactrouterdom.Link, { to: patientLoginRoute, onClick: onPatientSignIn, __self: this, __source: {fileName: _jsxFileName, lineNumber: 249}}, "Patient sign-in" )
            )
          )
        )
      )
    )
  )
}

exports. default = EnterEmail
